import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPage, updatePageOpeningHours } from '../../../actions/admin/pageAction';
import OpeningHoursBase from '../../openingHours/openingHours';

const OpeningHours = (props) => (
  <OpeningHoursBase
    {...props}
    hasExceptions
    getEntity={props.getEntity}
    updateEntity={props.isUsingAction ? props.updateEntity : null}
  />
);

const mapDispatchToProps = (dispatch) => ({
  getEntity:    (id) => dispatch(getPage(id)),
  updateEntity: (data, id) => dispatch(updatePageOpeningHours(data, id)),
});

OpeningHours.defaultProps = {
  isUsingAction: false,
};

OpeningHours.propTypes = {
  getEntity:     PropTypes.func.isRequired,
  updateEntity:  PropTypes.func.isRequired,
  isUsingAction: PropTypes.bool,
};

export default connect(null, mapDispatchToProps)(OpeningHours);
